import { replace } from 'lodash'

export const ICON_FAMILIES = [
  {
    familyName: 'Classic',
    familyDescription: 'Four styles that are always in fashion and ready to bring that extra level of iconic flair to projects.',
    styles: [
      {
        cardColor: 'teal',
        isDarkTheme: false,
        isNew: false,
        fullStyleName: 'solid',
        styleName: 'solid',
        styleDescription: 'Great for bold statements or small sizes.'
      },
      {
        cardColor: 'blue',
        isDarkTheme: false,
        isNew: false,
        fullStyleName: 'regular',
        styleName: 'regular',
        styleDescription: 'Easy, readable icons that blend right in.'
      },
      {
        cardColor: 'purple',
        isDarkTheme: false,
        isNew: false,
        fullStyleName: 'light',
        styleName: 'light',
        styleDescription: 'When a lighter touch is needed.'
      },
      {
        cardColor: 'yellow',
        isDarkTheme: false,
        isNew: false,
        fullStyleName: 'thin',
        styleName: 'thin',
        styleDescription: 'Fits in with the lastest super-light designs.'
      }
    ]
  },
  {
    familyName: 'Sharp',
    familyDescription: 'Cuts a clean, modern look that pairs nicely with sharp typefaces, crisp occassions, and precise projects.',
    styles: [
      {
        cardColor: 'teal',
        isDarkTheme: true,
        isNew: false,
        fullStyleName: 'sharpSolid',
        styleName: 'solid',
        styleDescription: 'A dash of class for a bold, sharp look.'
      },
      {
        cardColor: 'blue',
        isDarkTheme: true,
        isNew: false,
        fullStyleName: 'sharpRegular',
        styleName: 'regular',
        styleDescription: 'Sharpen your designs with these reliable icons.'
      },
      {
        cardColor: 'purple',
        isDarkTheme: true,
        isNew: false,
        fullStyleName: 'sharpLight',
        styleName: 'light',
        styleDescription: 'Add a breezy, light touch of modern elegance.'
      },
      {
        cardColor: 'yellow',
        isDarkTheme: true,
        isNew: false,
        fullStyleName: 'sharpThin',
        styleName: 'thin',
        styleDescription: 'Capture a clean, razor-sharp, look and feel.'
      }
    ]
  },
  {
    familyName: 'Duotone',
    familyDescription: 'Add a two-tone illustrated touch with tons of color styling for projects that want to pop.  Pairs well with our other Classic styles.',
    styles: [
      {
        cardColor: 'teal',
        isDarkTheme: false,
        isNew: false,
        fullStyleName: 'duotone',
        styleName: 'solid',
        styleDescription: 'For an attention grabbing illustrated look-and-feel.'
      },
      {
        cardColor: 'blue',
        isDarkTheme: false,
        isNew: true,
        fullStyleName: 'duotoneRegular',
        styleName: 'regular',
        styleDescription: 'A two-tone style that pairs with regular icons.'
      },
      {
        cardColor: 'purple',
        isDarkTheme: false,
        isNew: true,
        fullStyleName: 'duotoneLight',
        styleName: 'light',
        styleDescription: 'Hint at illustrated elegance in two tones.'
      },
      {
        cardColor: 'yellow',
        isDarkTheme: false,
        isNew: true,
        fullStyleName: 'duotoneThin',
        styleName: 'thin',
        styleDescription: 'Airy and refined take on illustrated icons.'
      }
    ]
  },
  {
    familyName: 'Sharp Duotone',
    familyDescription: 'Get that crisp Sharp look with an illustrated feel.  Pairs well with our other Sharp styles.',
    styles: [
      {
        cardColor: 'teal',
        isDarkTheme: true,
        isNew: false,
        fullStyleName: 'sharpDuotoneSolid',
        styleName: 'solid',
        styleDescription: 'An extra sharp take on our Duotone icons.'
      },
      {
        cardColor: 'blue',
        isDarkTheme: true,
        isNew: true,
        fullStyleName: 'sharpDuotoneRegular',
        styleName: 'regular',
        styleDescription: 'A two-tone take on Sharp Regular icons.'
      },
      {
        cardColor: 'purple',
        isDarkTheme: true,
        isNew: true,
        fullStyleName: 'sharpDuotoneLight',
        styleName: 'light',
        styleDescription: 'Double your elegance with this light style.'
      },
      {
        cardColor: 'yellow',
        isDarkTheme: true,
        isNew: true,
        fullStyleName: 'sharpDuotoneThin',
        styleName: 'thin',
        styleDescription: 'Cut to the chase with this crisp, two-tone style.'
      }
    ]
  }
]

export function getIconString(style, iconName) {
  return this.$v7[style]?.[iconName] || this.$v7['sharpDuotoneSolid']['faQuestion']
}

export function hyphenatedFamilyName(familyName) {
  return replace(familyName, ' ', '-').toLowerCase()
}
